/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { pct } from 'cio/helpers/pct';
import { inject as service } from '@ember/service';
import COLOR_LABELS from 'cio/utils/color-labels';

import DS from 'ember-data';
import { Measure } from 'cio/utils/metrics/common';
import { Metric } from 'cio/utils/metrics/models/metric';
import { TestMetricType } from 'cio/models/newsletter';
import NewsletterModel from 'cio/models/newsletter';
import EnvironmentService from 'cio/services/environment';
import TemplateModel from 'cio/models/template';

interface MetricCell {
  metric: Measure;
  value: string | number;
  subvalue?: string;
}

interface TestResultsRowArgs {
  index: number;
  template: TemplateModel;
  metric: Metric;
  highlightedRow: TestMetricType;
  highlightedColumn: string;
  canSendToRemaining: boolean;
  newsletter: NewsletterModel;
  visibleMetrics: Measure[];
  toggleSendToRemainingModal: () => unknown;
}

export default class Row extends Component<TestResultsRowArgs> {
  @service store!: DS.Store;
  @service environment!: EnvironmentService;

  get labelClassNames() {
    if (this.args.highlightedColumn !== this.args.template.id) {
      return;
    }

    let label = COLOR_LABELS[this.args.index];
    return `newsletter-test-results-row--${label?.color ?? 'translation'}`;
  }

  get denominator() {
    let denominator: Measure = this.environment.current.metricDenominator;

    if (!this.args.newsletter?.channelInfo.metrics.includes(denominator)) {
      denominator = 'sent';
    }

    return denominator;
  }

  get metricCells(): MetricCell[] {
    let { metric } = this.args;

    return [
      {
        metric: this.denominator,
        value: metric[this.denominator].allTimeTotal,
      },
      ...['opened', 'clicked', 'converted', 'failed'].map((measure: Measure) => ({
        metric: measure,
        value: pct([metric[measure]!.allTimeRate], { precision: 1 }),
        subvalue: `${metric[measure]!.allTimeTotal}`,
      })),
    ];
  }

  get visibleMetricCells(): MetricCell[] {
    return this.metricCells.filter((cell) => this.args.visibleMetrics.includes(cell.metric));
  }
}
